// extracted by mini-css-extract-plugin
export default {"Bio":"Bio_Bio__WA7lF","Bio__Paragraph":"Bio_Bio__Paragraph__zmBFA","Bio__Closing":"Bio_Bio__Closing__ovqbw"};